<template> <!-- OK -->
  <div class="group-table-container">
    <h2>{{ selectedGroup?.name }}</h2>
    <div ref="groupDropDown" class="dropdown">
      <button class="btn-dropdown" @click="toggleGroupDropdown">{{ selectedGroup?.name }} <span>&#9660;</span></button>
      <div v-if="showGroupDropdown" class="group-dropdown">
        <ul>
          <li v-for="group in groups" :key="group.id" @click="selectGroup(group.id)">
            {{ group.name }}
          </li>
        </ul>
      </div>
    </div>
    <div class="table-wrapper">
      <table class="group-table">
        <thead>
        <tr>
          <th>POS</th>
          <th>JOGADOR</th>
          <th>VITÓRIAS</th>
          <th>JOGOS</th>
          <th>SET AVER.</th>
          <th>GAMES</th>
          <th>ACELERAÇÃO</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(player, index) in groupPlayers" :key="player.id">
          <td :class="getRowClass(index, selectedGroup)">{{ index + 1 }}</td>
          <td>
            <div class="player-info">
              <span class="player-name">{{ player.User.fullName }}</span>
              <a class="whatsapp-btn" :href="getWhatsappLink(player.User.phone)" target="_blank" rel="noopener noreferrer">
                <img class="wpp-icon" src="../assets/whatsapp.png" alt="whatsapp icon">
              </a>
            </div>
          </td>
          <td>{{ player.victories }}</td>
          <td>{{ player.jogos }}</td>
          <td>{{ player.setAverage }}</td>
          <td>{{ player.games }}</td>
          <td>{{ formatarMedia(player.average) }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    groups: Array,
    selectedGroup: Object,
    groupPlayers: Array,
  },
  data() {
    return {
      showGroupDropdown: false,
    };
  },
  methods: {
    toggleGroupDropdown() {
      this.showGroupDropdown = !this.showGroupDropdown;

      if(this.showGroupDropdown) {
        document.addEventListener("click", this.closeDropDownClickOutside);
      }
    },
    closeDropDownClickOutside() {
      const dropdown = this.$refs.groupDropDown;
      if (dropdown && !dropdown.contains(event.target)) {
        this.showGroupDropdown = false;
        document.removeEventListener("click", this.closeDropDownClickOutside);
      }
    },
    selectGroup(groupId) {
      this.$emit('select-group', groupId);
      this.showGroupDropdown = false;
    },
    getRowClass(index, group) {
      if (!group || !this.groups) {
        return '';
      }

      const lastIndex = this.groupPlayers.length - 1;
      const secondLastIndex = lastIndex - 1;

      if (index === 0 || index === 1) {
        return 'green'
      }

      if (index === lastIndex || index === secondLastIndex) {
        return 'red'
      } else {
        return 'black'
      }


      return '';
    },
    formatarMedia(valor) {
      return Math.ceil(valor * 10) / 10;
    },
    getWhatsappLink(phone) {
      if (!phone) {
        return '#';
      }

      if (phone.length < 10) {
        return '#';
      }

      return `https://wa.me/${phone}`
    }
  }
};
</script>

<style scoped>
.group-table-container {
  width: 90%;
  max-width: 1200px;
  /* margin: auto; */
  padding: 1rem;
  background-color: white;
  color: black;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.group-table-container h2 {
  text-align: center;
  margin-bottom: 1rem;
  font-size: 2rem;
  text-transform: uppercase;
  border-bottom: 1px solid black;
  padding-bottom: 0.5rem;
}

.btn-dropdown {
  display: block;
  margin: 1rem auto;
  background-color: #0056B3;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1.2rem;
}

.btn-dropdown:hover {
  background-color: #007BFF;
}

.group-dropdown {
  position: absolute;
  background-color: white;
  color: black;
  border: 1px solid #ddd;
  z-index: 100;
  width: 150px;
  max-height: 150px;
  overflow-y: scroll;
  margin-right: 0.5rem;
  text-align: left;
  left: 44.5%;
}

.group-dropdown ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.group-dropdown li {
  padding: 0.5rem;
  cursor: pointer;
}

.group-dropdown li:hover {
  background-color: #ddd;
}

.table-wrapper {
  overflow-x: auto;
}

.group-table {
  width: 100%;
  min-width: 600px;
  border-collapse: collapse;
  margin: auto;
}

.group-table th,
.group-table td {
  border: 1px solid #ddd;
  padding: 0.5rem;
  text-align: center;
}

.group-table th {
  background-color: #0056B3;
  color: white;
}

.group-table td {
  background-color: white;
  /* color: black; */
}

.green {
  color: green;
  font-weight: bold;
}

.red {
  color: red;
  font-weight: bold;
}

.black {
  color: #000;
  font-weight: bold;
}

.wpp-div {
  display: inline;
  align-content: center;
  justify-items: center;
}

.player-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.player-name{
  flex: 1;
  text-align: left;
}

.whatsapp-btn {
  width: 30px;
  height: 30px;
  cursor: pointer;
  background-color: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
}

.wpp-icon {
  width: 24px;
  height: 24px;
}

@media (max-width: 425px) {
  .group-table-container {
    width: 100%;
    padding: 0.5rem;
  }

  .group-table-container h2 {
    font-size: 1.2rem;
  }

  .btn-dropdown {
    font-size: 0.8rem;
    padding: 0.3rem 0.6rem;
  }

  .group-dropdown {
    width: 80%;
  }

  .group-table th,
  .group-table td {
    font-size: 0.8rem;
    padding: 0.3rem;
  }
}

@media (min-width: 426px) and (max-width: 768px) {
  .group-table-container {
    width: 100%;
    padding: 1rem;
  }

  .group-table-container h2 {
    font-size: 1.5rem;
  }

  .btn-dropdown {
    font-size: 1rem;
    padding: 0.4rem 0.8rem;
  }

  .group-dropdown {
    width: 200px;
  }

  .group-table th,
  .group-table td {
    font-size: 0.9rem;
    padding: 0.4rem;
  }
}
</style>
